import axios from "axios"
import qs from "qs"
import config from "./config"
// const vm = Vue.prototype
console.log(5, config)
// const service = axios.create({
//   baseURL: baseUrl, // api base_url
//   timeout: 60000, // 请求超时时间
// })
// service.interceptors.response.use((response) => {
//   return response.data
// })
const http = (methodPath, param, cusConfig = {}) => {
  // const aid = vm.$store.state.aid
  // 以空格分隔 method 和 path
  const methodPathArr = methodPath.split(" ")
  let method = methodPathArr[0]
  const path = methodPathArr[1]
  // 兼容 del 别名
  method === "del" ? method = "delete" : ""

  const axiosParam = {
    method: method,
    url: `${config.http.base}${path}`,
    headers: {
      // "Content-type": "application/x-www-form-urlencoded",
      "Content-type": "application/json",
      // "aid": aid,
    },
  }

  const token = localStorage.getItem("token")
  if (token) {
    axiosParam.headers.token = token
  }

  switch (method) {
    case "get":
    case "delete":
      axiosParam.params = param
      break
    case "post":
    case "put":
      axiosParam.data = param
      break
    default:
      break
  }

  return new Promise((resolve, reject) => {
    // console.log(30);
    
    try {
      axios({
        ...cusConfig,
        ...axiosParam,
      }).then((res) => {
        // let res = resAxios.data
        // console.log(38)
        // console.log(38, res.data)
        const data = res.data
        let pages;
        let page
        switch (data.code) {
          case 401: // 401 未登录，403 拒绝访问，无权限访问
            console.log(45, data);
            new Promise((resolve2) => {
              // pages = getCurrentPages()
              // page = pages[pages.length - 1]
              // console.log(43, pages, page)
              // currentWebview = pages[pages.length - 1].$getAppWebview()
              // if (currentWebview.__uniapp_route
              // != "pages/msg-center/msg-center") {
              //   uni.switchTab({url: "/pages/msg-center/msg-center"})
              // }
              localStorage.removeItem("token")
              location.reload();
              // if (page && [
              //     "pages/user/register",
              //     "pages/user/login",
              //   ].includes(page.route)) {
              //   // vm.$store.commit(
              //   //     "loginRedirect",
              //   //     `/${currentWebview.__uniapp_route}`,
              //   // )

              //   vm.$redi("/pages/user/login")
              // } else {
              //   // vm.$store.commit("loginRedirect", `/pages/index/index`)

              //   vm.$redi("/pages/user/login")
              // }
              resolve2()
            })


            // uni.showToast({
            // title:''
            // })
            reject(res)
            break
          default:
            resolve(res.data)
            break
        }
      })
    } catch (error) {
      console.log(90)
      reject(error)
    }
  })
}

export default http
